import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: 'input[numbersAndSlashOnly]',
})
export class NumbersAndSlashDirective {

    constructor(private _el: ElementRef) {}

    @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent) {
        const input = this._el.nativeElement;
        if (event.key === 'Backspace' && input.value.endsWith('/')) {
            input.value = input.value.slice(0, -1);
            event.preventDefault();
        }
    }

    @HostListener('input', ['$event']) onInputChange(event: any) {
        const input = this._el.nativeElement;
        const initialValue = input.value;
        let value = initialValue.replace(/[^\d]/g, '');
        value = value.slice(0, 8);
        if (value.length >= 2) value = value.slice(0, 2) + '/' + value.slice(2);
        if (value.length >= 5) value = value.slice(0, 5) + '/' + value.slice(5);
        input.value = value;
        if (initialValue !== input.value) {
            event.stopPropagation();
            input.dispatchEvent(new Event('input', { bubbles: true }));
        }
    }
}